import { defineAsyncComponent } from 'vue';

import { toPlugin, type ComponentType, type Plugin } from '@bv/helpers/components';

export { default as BvWorkflowBuilder } from './components/BvWorkflowBuilder.vue';

export const workflowArray: ComponentType[] = [
  {
    name: 'BvWorkflowBuilder',
    component: defineAsyncComponent(() => import('./components/BvWorkflowBuilder.vue')),
  },
];

export const workflow: Plugin<[]> = toPlugin(workflowArray);
